module.exports = __webpack_public_path__ + "static/media/freeDelivery1.85666e17.png";